import { create } from 'zustand'
import { LeaveRequestSource } from '../database/enums/LeaveRequestSource.enum'

interface IAdminLeaveRequestsUnrespondedPageStore {
  selectedSourceTab: LeaveRequestSource
}

const adminLeaveRequestsUnrespondedPageStore = create<IAdminLeaveRequestsUnrespondedPageStore>()(() => ({
  selectedSourceTab: LeaveRequestSource.INDO,
}))

export default adminLeaveRequestsUnrespondedPageStore
